import React, { useEffect, useState } from "react";
import { Dropdown, Tooltip } from "antd";
import { useMediaQuery } from "react-responsive";
import { DownCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ThemeColor } from "../../../../Theme/theme";
// import { Fasttag } from "../../../Assets/fastag";
// import { Mobile_Prepaid } from "../../../Assets/mobile prepaid";
// import { Mobile_PostPaid } from "../../../Assets/mobile postpaid";
// import { DataCard } from "../../../Assets/datacard_icon";
// import { Creditcard } from "../../../Assets/Creditcard";
// import { DTH } from "../../../Assets/dth";
// import { Electricity } from "../../../Assets/Electricity";
// import { Gas_Icon } from "../../../Assets/gas_icon";
// import { Water } from "../../../Assets/water_icon";
// import { Cable } from "../../../Assets/cable";
// import { Club } from "../../../Assets/club";
// import { Hospital } from "../../../Assets/hospital";
// import { HousingSociety } from "../../../Assets/housing society";
// import { Insurance } from "../../../Assets/insurance";
// import { Landline } from "../../../Assets/landline";
// import { Loan } from "../../../Assets/loan";
// import { Municiple_service } from "../../../Assets/municipal service";
// import { Subscription } from "../../../Assets/subscription";
// import { Municipal_Tax } from "../../../Assets/municipal tax";
// import { Lpg_Gas } from "../../../Assets/LPG Gas";
import NotAvailable from "../../../../Routes/NotAvailable";
// import Entertainment from "../../../Assets/Entertainment";
// import Broadband from "../../../Assets/Broadband";
import { useSearchParams } from "react-router-dom";
import {
  setHeadings,
  setselectedTab,
  setSubHeadings,
} from "../../../../Store/B2bslice";
import { Mobile_PostPaid } from "../../../../Assets/mobile postpaid";
import { getBbpsOfflineOperatorCategory } from "../EkoEndpoint";
import EkoBBPSOffline from "./EkoBBPSOffline";
const OperatorsCategoryOffline = () => {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState("");
  const [allOperatorsCategoryOffline, setAllOperatorsCategoryOffline] =
    useState([]);
  const isExtraLargeScreen = useMediaQuery({ minWidth: 1501, maxWidth: 4000 });
  const isLargeScreen = useMediaQuery({ minWidth: 992, maxWidth: 1500 });
  const isMediumScreen = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isSmallScreen = useMediaQuery({ minWidth: 400, maxWidth: 767 });
  const isExtraSmallScreen = useMediaQuery({ minWidth: 250, maxWidth: 500 });
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [searchParam] = useSearchParams();

  const getAllOperatorsCategoryOffline = () => {
    getBbpsOfflineOperatorCategory().then((res) => {
      if (res.status) {
        setAllOperatorsCategoryOffline(
          res.data?.map((i, id) => ({
            operator_category_name: i.operator_category_name,
            component: !memberServices.includes("2") ? (
              <NotAvailable />
            ) : (
              <EkoBBPSOffline
                selection={i.operator_category_name}
                type={i.key}
              />
            ),

            key: id,
          }))
        );
      }
    });
  };

  useEffect(() => {
    getAllOperatorsCategoryOffline();
  }, [selection]);

  useEffect(() => {
    const service = searchParam.get("service");
    console.log("test", service);
    setSelection(service);
  }, [searchParam]);

  const itemsToShow = isExtraLargeScreen
    ? 9
    : isLargeScreen
    ? 9
    : isMediumScreen
    ? 3
    : isSmallScreen
    ? 1
    : isExtraSmallScreen
    ? 1
    : allOperatorsCategoryOffline.length;

  // const items = tabNames.slice(itemsToShow).map((item, index) => {
  //   return (
  //     <div
  //       key={index}
  //       onClick={() => setSelection(item.name)}
  //       className="flex bg-primary hover:bg-primaryhover rounded-full  text-white p-2 justify-around w-14 h-14 items-center"
  //     >
  //       {/* <img src={item.image} className="" alt="service_image" width={"15px"} /> */}
  //       <div>{item.image}</div>
  //       <p className=" cursor-pointer flex justify-end items-start transition-all bg-transparent   font-bold rounded-sm text-[13px] px-5">
  //         {item.name}
  //       </p>
  //     </div>
  //   );
  // });
  const items = allOperatorsCategoryOffline
    .slice(itemsToShow)
    .map((item, index) => {
      0;
      return {
        key: index,
        label: (
          <div
            key={index}
            onClick={() => setSelection(item.operator_category_name)}
            className="flex bg-primary hover:bg-primaryhover rounded-md text-white p-2 justify-start w-full items-center"
          >
            {/* <img
            src={item.image}
            className=""
            alt="service_image"
            width={"15px"}
          /> */}
            <Mobile_PostPaid style={ThemeColor.bswhite} />
            {/* <div>{item?.image}</div> */}

            <p className=" cursor-pointer capitalize flex justify-end items-start transition-all bg-transparent   font-bold rounded-sm text-[13px] px-5">
              {item.operator_category_name}
            </p>
          </div>
        ),
      };
    });
  useEffect(() => {
    dispatch(setSubHeadings(""));
    dispatch(setselectedTab("201"));
    dispatch(setHeadings("Operator Category"));
  }, [selection]);
  return (
    <>
      <div className="All_services bg-white p-10 rounded-md mb-5 gap-4 flex justify-around flex-wrap items-center">
        {allOperatorsCategoryOffline
          .slice(0, itemsToShow)
          .map((item, index) => {
            return (
              <div key={index}>
                <div
                  onClick={() => setSelection(item.operator_category_name)}
                  className=" p-3 w-14 h-14 hover:scale-110  cursor-pointer hover:opacity-100 bg-primary rounded-full hover:bg-primaryhover text-white transition-all flex flex-col justify-center items-center font-bold  "
                >
                  <Mobile_PostPaid style={ThemeColor.bswhite} />
                </div>
                <p className={`text-[13px] font-semibold text-center`}>
                  {item.operator_category_name}
                </p>
                {selection === item.operator_category_name ? (
                  <div className="animate-slide-in mt-1 border border-primary "></div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        {(isExtraLargeScreen ||
          isLargeScreen ||
          isMediumScreen ||
          isSmallScreen ||
          isExtraSmallScreen) && (
          <Dropdown
            className="dropdownMenu"
            menu={{ items }}
            trigger={["click"]}
          >
            <div className="p-3  cursor-pointer bg-primary mb-4 rounded-full hover:opacity-60 text-white transition-all  border border-primary font-bold flex flex-col gap-y-1 justify-center items-center text-xs ">
              <p>More</p>
              <DownCircleOutlined className="" />
            </div>
          </Dropdown>
        )}
      </div>

      {
        allOperatorsCategoryOffline.filter(
          (item, index) => item.operator_category_name === selection
        )[0]?.component
      }
    </>
  );
};

export default OperatorsCategoryOffline;
